import React from 'react';
import { useTranslation } from 'react-i18next';
import { convertTime24To12 } from 'src/utils/util';
import { formatDateddmmmyy, getDisplayDate } from 'src/utils/dateUtils';
import FlagRed from 'src/assets/images/Alert icon 1.svg';
import {
    MainContainerItems,
    Subtitle,
    Title,
    Bar,
    NotesHorizontalLine,
} from './reviewAndSubmitNotes.styled';

// "Usage Adjustment Notes" group for the Report Usage review & submit screen.
const UsageAdjNotesReview = ({
    title,
    notes = [],
    displayName,
    countryISOCode,
    isSubmitClicked,
    emptyText,
    mobile = false,
    showImportantMessage = false,
    importantMessage,
}) => {
    const { t } = useTranslation();

    if (notes.length <= 0 && isSubmitClicked) {
        return null;
    }

    return (
        <>
            <NotesHorizontalLine />
            <Title
                style={{
                    marginLeft: mobile ? '20px' : undefined,
                    color: mobile ? '#030330' : undefined,
                }}
            >
                {title}
            </Title>
            {showImportantMessage && (
                <div
                    style={{
                        marginLeft: mobile ? '20px' : undefined,
                        marginBottom: '10px',
                    }}
                >
                    <span
                        style={{
                            color: '#ED002A',
                            fontSize: '13px',
                            fontFamily: 'AvenirNextWorld Regular',
                            display: 'flex',
                        }}
                    >
                        <img src={FlagRed} alt="icon" height={'20px'} width={'20px'} />
                        {importantMessage}
                    </span>
                </div>
            )}
            {notes.length > 0 ? (
                notes.map((item, index) => (
                    <MainContainerItems
                        key={index}
                        setMarginBottom={true}
                        setWidth="100%"
                        mbSetWidth="100%"
                        borderLeft={
                            item.isNew && !isSubmitClicked
                                ? '2px solid #12C8F7'
                                : 'none'
                        }
                        paddingLeft="20px"
                        marginLeft="-20px"
                    >
                        <div style={{ display: 'flex' }}>
                            <Subtitle
                                showAstrisk={false}
                                fontSize="12px"
                                font={'AvenirNextWorld Demi'}
                            >
                                <b style={{ marginRight: '10px' }}>
                                    {t('equity.surgery.createdBy')} {displayName}{' '}
                                </b>{' '}
                            </Subtitle>
                            <Subtitle width={'65%'}>
                                {!mobile && (
                                    <Bar marginRight={'10px'}>|</Bar>
                                )}
                                {mobile
                                    ? getDisplayDate(item.creationDate)
                                    : formatDateddmmmyy(
                                          item.creationDate,
                                          countryISOCode,
                                          true
                                      )}
                                <Bar marginLeft={'10px'} marginRight={'10px'}>
                                    |
                                </Bar>{' '}
                                {convertTime24To12(new Date(item.creationDate))}{' '}
                            </Subtitle>
                        </div>
                        <Subtitle>{item.note}</Subtitle>
                    </MainContainerItems>
                ))
            ) : (
                <div
                    style={{
                        fontFamily: 'AvenirNextWorld Italic',
                        fontSize: '14px',
                        color: '#202124',
                        opacity: '0.7',
                        marginLeft: mobile ? '20px' : undefined,
                    }}
                >
                    {emptyText}
                </div>
            )}
        </>
    );
};

export default UsageAdjNotesReview;
